// extracted by mini-css-extract-plugin
module.exports = {"elements":"ShareElements_elements__xsrtS","btn":"ShareElements_btn__dmCjo","icon":"ShareElements_icon__Mj5BI","label":"ShareElements_label__OphoN"};